import { TFunction } from 'i18next';

import projectConfig, { PROJECT } from '~/projects/config';

type PaymentConfig = {
  getCompanyAddress: (t: TFunction, country?: string) => string;
};

const TECHWAVE_COMPANY_ADDRESS =
  'Techwave Solutions Limited 9205 West Russell Road Building 3, Suite 240, Las Vegas, Nevada, 89148, USA';

const isUnitedStates = (country?: string): boolean => {
  const normalizedCountry = country?.trim().toLowerCase();

  return (
    normalizedCountry === 'us' ||
    normalizedCountry === 'usa' ||
    normalizedCountry === 'united states' ||
    normalizedCountry === 'united states of america'
  );
};

const paymentConfigByProject: Readonly<Record<PROJECT, PaymentConfig>> = {
  [PROJECT.JUSTDONE]: {
    getCompanyAddress: (t: TFunction, country?: string) =>
      isUnitedStates(country)
        ? t(
            'subscription:payment_form.agreement_justdone_us',
            TECHWAVE_COMPANY_ADDRESS,
          )
        : t(
            'subscription:payment_form.agreement_justdone',
            'GM Appdev Limited, with registered address at Nafpliou, 15, Limassol, Cyprus, 3025',
          ),
  },
  [PROJECT.SIDEKICKER]: {
    getCompanyAddress: (t: TFunction, country?: string) =>
      isUnitedStates(country)
        ? t(
            'subscription:payment_form.agreement_sidekicker_us',
            TECHWAVE_COMPANY_ADDRESS,
          )
        : t(
            'subscription:payment_form.agreement_sidekicker',
            'AV Wellbeing Limited. Florinis, 7, Greg Tower, 2nd floor, 1065, Nicosia, Cyprus',
          ),
  },
};

const getConfigByProject = (): PaymentConfig => {
  return paymentConfigByProject[projectConfig.project];
};

export const PAYMENT_PROJECT_CONFIG = getConfigByProject();
